export { templatesListRoute } from './TemplatesList'
export { templateEditRoute } from './TemplateManage'
export { templateDetailsRoute } from './TemplateDetails'
